import DashboardLayout from '@/routes/dashboard/DashboardLayout'
import { createCoreRoutes } from './core/core'
import { createContentViewerRoutes } from './contentViewer'
import { createMatterRoutes } from './matter/matter'
import type { RouteFactory } from '../types'
import { createLegacyRedirects } from './matter/legacyRedirects'
import { OnboardingFlowGate } from '@/components/guards/OnboardingFlowGate'
import DashboardSignInGate from '@/components/guards/DashboardSignInGate'

/**
 * Creates the dashboard route with all child routes assembled.
 * Wraps everything in OnboardingFlowGate, which selects the account-setup flow or dashboard guards.
 * With `ONBOARDING_REFRESH_AUTH_PAGES` on, DashboardSignInGate sits right around the layout so a
 * signed-out visitor never sees the sidebar.
 *
 * Route hierarchy:
 * - Core routes (home, admin, account, drives, settings, matters)
 * - Content viewer routes (reference-viewer)
 * - Matter-first routes (/dashboard/m/:matterId/...)
 * - Legacy redirects (catch old URLs and redirect to matter-first)
 */
export const createDashboardRoutes: RouteFactory = () => [
  {
    path: 'dashboard',
    element: (
      <OnboardingFlowGate>
        <DashboardSignInGate>
          <DashboardLayout />
        </DashboardSignInGate>
      </OnboardingFlowGate>
    ),
    children: [
      // Core routes (home, admin, account, drives, settings, matters)
      ...createCoreRoutes(),

      // Content viewer routes
      ...createContentViewerRoutes(),

      // Matter-first routes
      // /dashboard/m/:matterId/chronology, /chat, /billing-summaries, /files
      ...createMatterRoutes(),

      // Legacy redirects: feature-first → matter-first URL migration
      // Catches old URLs like /dashboard/medical-chronology/m/:matterId and redirects to new matter-first URLs like /dashboard/m/:matterId/medical-chronology
      ...createLegacyRedirects(),
    ],
  },
]
